import cm from 'classnames';

import { useAppSelector } from 'store/store-hooks';
import { Button } from 'components/UI/button/button';
import styles from './_placeholders.module.scss';

interface Props {
  cb: () => void;
}

export const PlaceholderProjects = ({ cb }: Props) => {
  const projects = useAppSelector((state) => state.app__data.projects);
  if (!projects || projects.length) return;
  return (
    <div className={styles.Placeholder}>
      <div className={styles.Placeholder__container}>
        <div className={styles.Placeholder__title}>There are no projects</div>
        <Button onClick={cb} className={cm(styles.Placeholder__button)}>
          Add Project
        </Button>
      </div>
    </div>
  );
};
